import { SchemaOf, object, string, number, boolean } from 'yup';

import { UpgradeHelmFormValues } from './types';

export const validation: SchemaOf<UpgradeHelmFormValues> = object({
  version: string().required('Please select a version to upgrade to.'),
  repo: string(),
  registryId: number(),
  chart: string().required('Please select a chart.'),
  values: string(),
  atomic: boolean().required('Please select a rollback strategy.'),
})
  .test(
    'either-registry-or-repo-registryId',
    function validateRegistryId(values) {
      if (!values.registryId && !values.repo) {
        return this.createError({
          path: 'registryId',
          message: 'Please select a registry or repository.',
        });
      }
      return true;
    }
  )
  .test('either-registry-or-repo-repo', function validateRepo(values) {
    if (!values.registryId && !values.repo) {
      return this.createError({
        path: 'repo',
        message: 'Please select a registry or repository.',
      });
    }
    return true;
  });
